import { createSlice } from "@reduxjs/toolkit";

export interface CommonStateType {
  loading: number;
}

const initialState: CommonStateType = {
  loading: 0,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setLoading: (state) => ({ ...state, loading: state.loading + 1 }),
    removeLoading: (state) => ({ ...state, loading: state.loading - 1 }),
    resetLoading: (state) => ({ ...state, loading: 0 }),
  },
});

export const commonActions = commonSlice.actions;

export default commonSlice.reducer;
